import { render, staticRenderFns } from "./emailNotConfirm.vue?vue&type=template&id=01d435cd&scoped=true"
import script from "./emailNotConfirm.vue?vue&type=script&lang=js"
export * from "./emailNotConfirm.vue?vue&type=script&lang=js"
import style0 from "./emailNotConfirm.vue?vue&type=style&index=0&id=01d435cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d435cd",
  null
  
)

export default component.exports